function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Badge from '@material-ui/core/Badge';
import Spinner from './components/spinner';
import animClasses from './appear.anim.scss';
import classes from './badge-number.scss';
const baseAnimationClasses = {
  enter: animClasses.enter,
  exit: animClasses.exit,
  enterDone: animClasses.enterDone,
  exitDone: animClasses.exitDone
};
const increaseAnimClasses = _objectSpread({}, baseAnimationClasses, {
  exitActive: animClasses.hideToBottomClass,
  enterActive: animClasses.popFromTopClass
});
const decreaseAnimClasses = _objectSpread({}, baseAnimationClasses, {
  exitActive: animClasses.hideToTopClass,
  enterActive: animClasses.popFromBottomClass
});
const addedToCartTextAnimClasses = {
  enter: animClasses.textEnter,
  exitActive: animClasses.textExitActive,
  enterActive: animClasses.textEnterActive,
  enterDone: animClasses.textEnterDone
};
export default class BadgeNumber extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.itemsNumber !== prevState.currentNumber) {
      return {
        currentNumber: nextProps.itemsNumber,
        prevNumber: prevState.currentNumber,
        isLoading: nextProps.isLoading,
        isDecreasing: prevState.currentNumber > nextProps.itemsNumber
      };
    }
    if (nextProps.isLoading !== prevState.isLoading) {
      return {
        isLoading: nextProps.isLoading
      };
    }
    return prevState;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "textToShowTimeout", void 0);
    _defineProperty(this, "getBadgeContent", (animClasses, isHidden) => {
      const {
        currentNumber
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames({
          [classes.hidden]: isHidden
        })
      }, /*#__PURE__*/React.createElement(SwitchTransition, {
        mode: "out-in"
      }, /*#__PURE__*/React.createElement(CSSTransition, {
        classNames: animClasses,
        key: currentNumber,
        timeout: 350,
        unmountOnExit: true,
        mountOnEnter: false
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.badgeTextWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.badgeText
      }, currentNumber)))));
    });
    this.state = {
      prevNumber: props.itemsNumber,
      currentNumber: props.itemsNumber,
      isLoading: props.isLoading,
      isDecreasing: false
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isLoading,
      isDecreasing
    } = this.state;
    const {
      showText = false
    } = this.props;
    if (!showText) {
      return null;
    }
    if (prevProps.isLoading && !isLoading && !isDecreasing) {
      let textToShow = 'Added to Cart';
      if (window && window.innerWidth < 1500) {
        textToShow = 'Added';
      }
      if (window && window.innerWidth < 1150) {
        textToShow = '';
      }
      this.setState({
        textToShow
      });
      clearTimeout(this.textToShowTimeout);
      this.textToShowTimeout = setTimeout(() => this.setState({
        // @todo. auto generated. fix this error
        // @ts-ignore
        textToShow: null
      }), 4500);
    }
  }
  render() {
    const {
      isLoggedIn = true,
      iconComponent,
      badgeClassName,
      spinnerClassName,
      showText = false
    } = this.props;
    const {
      isDecreasing,
      isLoading,
      textToShow
    } = this.state;
    return /*#__PURE__*/React.createElement(Badge, {
      classes: {
        badge: classnames(classes.badge, badgeClassName)
      },
      color: "secondary",
      showZero: isLoggedIn,
      badgeContent: isLoggedIn ? /*#__PURE__*/React.createElement(React.Fragment, null, this.getBadgeContent(increaseAnimClasses, isDecreasing), this.getBadgeContent(decreaseAnimClasses, !isDecreasing), /*#__PURE__*/React.createElement(Spinner, {
        spinnerClassName: spinnerClassName,
        isLoading: isLoading
      })) : 0
    }, showText && /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: addedToCartTextAnimClasses,
      in: !!textToShow,
      timeout: 6500
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.addedToCart
    }, textToShow)), iconComponent);
  }
}